import { useQuery } from 'react-query';
import { NarrativeRequest } from 'utilitys/narrative/narrativeTools';

import { getProjectStatusScoreCards as queryFn } from 'api/endPoints/getProjectStatusScoreCards';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetProjectStatusScoreCards = (params: QueryParams) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, (QueryKeys | QueryParams)[]>({
        queryKey: ['getProjectStatusScoreCards', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.latestVersionId) && Boolean(params.contractId) && Boolean(params.compareVersionId),
    });
};

export interface QueryParams extends NarrativeRequest {
    compareVersionId: number | undefined;
    contractId: number | null | undefined;
    latestVersionId: number | undefined;
    filter: any;
}

export interface QueryResponse {
    info?: IToolTip;
    summaryCards: SummaryCard[];
}

interface Metric {
    id: string;
    name: string;
    value: number;
    valueType: string;
    link: string;
    info: IToolTip;
    threshold: {
        lowThreshold: number;
        mediumThreshold: number;
        highThreshold: number;
    };
    order: number;
    representation: string;
    fluxIndex: string;
}

export interface GraphPoints {
    versionName: string;
    versionDate: number;
    score: number;
    status: string;
    versionHashCode: number;
}

export interface SummaryCard {
    cardTitle: {
        title: string;
        status: string;
        cardType: 'QualityCard' | 'RiskCard' | 'ProgressCard';
    };
    overallScore: {
        value: number;
        threshold: {
            lowThreshold: number;
            mediumThreshold: number;
            highThreshold: number;
        };
    };
    cardProperties: {
        metrics: Metric[];
    };
    cardTrends: [
        {
            name: string;
            graphPoints: GraphPoints[];
        },
    ];
}
